import React from 'react';
import styles from './styles.module.scss';

export interface ILessonChartHeaderProps {
  coreLessonsHeader: string;
  supplementalLessonsHeader: string;
}

const Header = ({
  coreLessonsHeader,
  supplementalLessonsHeader,
}: ILessonChartHeaderProps) => {
  return (
    <div className={styles.header}>
      <span className={styles.item}>
        <span className={styles['icon-core']} />
        <span>{coreLessonsHeader}</span>
      </span>
      <span className={styles.item}>
        <span className={styles['icon-supplemental']} />
        <span>{supplementalLessonsHeader}</span>
      </span>
    </div>
  );
};

export default Header;
